import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Game from "../views/Game.vue";
import NewGame from "../views/NewGame.vue";
import GameStart from "../views/GameStart.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/game/:id",
    name: "GameStart",
    component: GameStart
  },
  {
    path: "/game/:id/:player",
    name: "Game",
    component: Game
  },
  {
    path: "/game/",
    name: "New",
    component: NewGame
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
